export default {
	编号: '编号:',
	标题: '标题',
	操作: '操作',
	订单编号: '订单编号',
	发布时间: '发布时间',
	发起时间: '发起时间',
	发送: '发送',
	附件: '附件',
	工单编号: '工单编号',
	工单不存在: '工单不存在',
	工单管理: '工单管理',
	工单类型: '类型',
	工单详情: '工单详情',
	工单已关闭: '工单已关闭',
	沟通记录: '沟通记录',
	关闭备注占位: '关闭备注（可选）',
	关闭工单: '关闭工单',
	关联订单: '关联订单',
	回复: '回复',
	回复内容: '回复内容',
	回复时间: '回复时间',
	加载中: '加载中',
	客服: '客服',
	客户: '客户',
	聊天功能即将上线: '聊天功能即将上线',
	没有更多: '没有更多',
	内容: '内容',
	请输入订单编号: '请输入订单编号',
	请输入工单标题: '请输入工单标题',
	请输入工单内容: '请输入工单内容',
	请输入回复内容: '请输入回复内容',
	请填写内容或上传附件: '请填写内容或上传附件',
	请选择类型: '请选择工单类型',
	请选择状态: '请选择状态',
	确认关闭工单: '确认关闭此工单？后续有问题，可以重新发起工单。',
	售后工单必须关联订单: '售后工单必须选择一个关联订单',
	搜索: '搜索',
	无关联: '无关联',
	无关联订单: '无关联订单',
	详情: '详情',
	新增工单: '新增工单',
	修改: '修改',
	修改工单: '修改工单',
	业务员: '业务员',
	暂无消息: '暂无消息',
	重置: '重置',
	状态: '状态',
}
